import React, { useState } from "react";
import Swal from "sweetalert2";
import api from 'api'
export default function ContactForm() {
  const [mm, setMm] = useState({
    mmFromName: "",
    mmFromEmail: "",
    mmSubject: "",
    mmBodyText: "",
    mmData: {
      company: "",
      phone: ""
    }
  });
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "company" || name === "phone") {
      setMm(prev => ({
        ...prev,
        mmData: {
          ...prev.mmData,
          [name]: value
        }
      }));
    } else {
      setMm(prev => ({
        ...prev,
        [name]: value
      }));
    }
    setErrors(prev => ({
      ...prev,
      [name]: false
    }));
  };
  const sendMessage = async () => {
    const newErrors = {};
    if (!mm.mmFromName) newErrors.mmFromName = true;
    if (!mm.mmFromEmail) newErrors.mmFromEmail = true;
    if (!mm.mmBodyText) newErrors.mmBodyText = true;
    if (!mm.mmData.phone) newErrors.mmDataPhone = true;
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      Swal.fire({
        text: "Merci de remplir les champs obligatoires"
      });
      return;
    }
    try {
      const payload = {
        ...mm
      };
      const res = await api.post("/contact",
        payload
      );
      const data = await res.data;
      if (data.success) {
        Swal.fire({
          text: "Votre message a bien été envoyé."
        });
        setMm({
          mmFromName: "",
          mmFromEmail: "",
          mmSubject: "",
          mmBodyText: "",
          mmData: {
            company: "",
            phone: ""
          }
        });
        setErrors({});
      } else {
        Swal.fire({
          text: "Une erreur est survenue."
        });
      }
    } catch (e) {
      console.log(e)
      Swal.fire({
        text: e.response?.data?.error?.message || "Erreur réseau."
      });
    }
  };
  return (
    <div className="card shadow-sm">
      <div className="card-body p-4">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">
              Nom et prénom *
            </label>
            <input
              type="text"
              name="mmFromName"
              value={mm.mmFromName}
              onChange={handleChange}
              className={`form-control ${errors.mmFromName ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">
              Champ obligatoire
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">
              Adresse e-mail *
            </label>
            <input
              type="email"
              name="mmFromEmail"
              value={mm.mmFromEmail}
              onChange={handleChange}
              className={`form-control ${errors.mmFromEmail ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">
              Champ obligatoire
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">
              Numéro de téléphone  *
            </label>
            <input
              type="text"
              name="phone"
              value={mm.mmData.phone}
              onChange={handleChange}
              className={`form-control ${errors.mmDataPhone ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">
              Champ obligatoire
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">
              Société représentée
            </label>
            <input
              type="text"
              name="company"
              value={mm.mmData.company}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-12">
            <label className="form-label">
              Message *
            </label>
            <textarea
              rows="6"
              name="mmBodyText"
              value={mm.mmBodyText}
              onChange={handleChange}
              className={`form-control ${errors.mmBodyText ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">
              Champ obligatoire
            </div>
          </div>
          <div className="col-12 text-end">
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={sendMessage}
            >
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}